import { Card } from 'components/Card';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import {
  selectAseFieldInstanceBelongsToInstances,
  selectAseId,
  selectAseIsOnline,
} from 'store/assessments/selectors';
import { InstanceParentParams } from 'store/assessments/types';
import { API_ASE_IMAGE } from 'service/api/constants';
import { selectUrlToken } from 'store/auth/selectors';
import { ICONS } from 'components/Icon';
import { RepeatableListItem } from './RepeatableListItem';

export const BelongsToField: React.FC<{
  instanceId: string;
  parent: InstanceParentParams;
}> = ({ instanceId, parent }) => {
  const belongsToInstances = useSelector((state) =>
    selectAseFieldInstanceBelongsToInstances(state, instanceId || '-1'),
  );
  const urlToken = useSelector(selectUrlToken);
  const assessmentId = useSelector(selectAseId);
  const isOnline = useSelector(selectAseIsOnline);
  if (!belongsToInstances.length) {
    return null;
  }
  return (
    <Card label="Belongs To..." labelIcon={ICONS.LinkHorizontalLight}>
      {belongsToInstances.map((belongsToInstanceId) => (
        <RepeatableListItem
          key={belongsToInstanceId}
          instanceId={belongsToInstanceId}
          from="inInstance"
          remoteImageUrl={
            isOnline ? API_ASE_IMAGE(assessmentId, { urlToken }) : undefined
          }
          parent={parent}
        />
      ))}
    </Card>
  );
};
